import { REASONS } from "../../data";
import { Reveal } from "./Reveal";

export const WhyChooseUs = () => (
  <section id="kenapa" className="relative py-24 sm:py-32 bg-[#f2ece4]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4">
          Alasan Memilih Kami
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2c1e16] max-w-3xl leading-tight">
          Kenapa Harus Memilih Kami
        </h2>
      </Reveal>

      <div className="mt-16 border-t border-[#e5d9c5]">
        {REASONS.map((r, i) => (
          <Reveal key={r.no} delay={i * 0.05}>
            <div
              data-testid={`reason-${r.no}`}
              className="group grid md:grid-cols-[auto_1fr] gap-6 md:gap-16 py-10 border-b border-[#e5d9c5] items-start"
            >
              <span className="font-display italic text-5xl sm:text-6xl text-[#b8862f] leading-none">
                {r.no}
              </span>
              <div className="md:flex md:items-start md:justify-between md:gap-16">
                <h3 className="font-display text-2xl sm:text-3xl text-[#2c1e16] md:max-w-xs leading-tight">
                  {r.title}
                </h3>
                <p className="mt-3 md:mt-1 text-[#5c4033] leading-relaxed md:max-w-md">
                  {r.desc}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
